export const BETA_ACCESS_FORM_URL =
  "https://forms.office.com/pages/responsepage.aspx?id=1zTEjNCX00e1xRT-DjPjSx13z01tAMxNqD8hfyaMo9VUMEVOSlc3RVhQMTFWWjVCV0VDUzFKTUQxRi4u&route=shorturl";
